<div class="dialog-container">

  <div class="dialog-header">
    <h2>Editar Macro</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
        <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

    <form [formGroup]="masterForm" (ngSubmit)="onConfirmar()">
      <div class="row">

        <div class="col-12 col-md-12 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome da Macro</mat-label>
            <input matInput formControlName="nome" maxlength="100" required />
            <mat-error *ngIf="masterForm.get('nome')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>


    <div class="row mt-3">
      <div class="col d-flex justify-content-end gap-2">
        <button mat-flat-button color="accent" type="submit" (click)="onConfirmar()"
          [disabled]="loading || !masterForm.valid || isUnchanged">
          <mat-icon>check</mat-icon> Confirmar
        </button>
        <button mat-flat-button type="button" (click)="onCancelar()" [disabled]="loading">
          <mat-icon>close</mat-icon> Cancelar
        </button>
      </div>
    </div>

  </div>

</div>
